{
  "navGroups": {
    "Telemetry": "Telemetry",
    "Blasts": "Blasts",
    "References": "References",
    "Targets": "Targets"
  },
  "header": {
    "toggleMenu": "Toggle menu",
    "closeMenu": "Close menu",
    "menu": "Menu",
    "logout": "Logout",
    "login": "Login",
    "user": "User",
    "themeDark": "Theme: Dark",
    "themeLight": "Theme: Light",
    "touchOn": "Touch layout: on",
    "touchOff": "Touch layout: off",
    "language": "Language",
    "allZones": "All zones",
    "zoneCount_one": "{{count}} zone",
    "zoneCount_other": "{{count}} zones",
    "yourZones": "Your zones"
  },
  "roles": {
    "Spectator": "Spectator",
    "User": "User",
    "Admin": "Admin",
    "Lead Admin": "Lead Admin",
    "Super Admin": "Super Admin"
  },
  "table": {
    "rowsRemoved_one": "A row you were editing was removed by a live update; your unsaved changes were discarded.",
    "rowsRemoved_other": "{{count}} rows you were editing were removed by a live update; your unsaved changes were discarded.",
    "loadFailedTitle": "Something went wrong",
    "loadFailed": "We couldn't load this data. Please try again.",
    "offlineTitle": "Not available offline",
    "offline": "This page hasn't been saved for offline use. Reconnect to load it; pages you opened before going offline stay available.",
    "singleEntry": "Showing a single entry. Filters and pagination are disabled.",
    "exitSingleEntry": "Exit Single Entry Mode",
    "noResults": "No results found.",
    "noData": "No data",
    "details": "Details",
    "lockTabbing": "Lock {{column}} tabbing",
    "unlockTabbing": "Unlock {{column}} tabbing",
    "filters": "Filters",
    "allOf": "All {{label}}",
    "offlinePages": "Offline: only saved pages are available",
    "errorFallback": "Error"
  },
  "actions": {
    "save": "Save",
    "delete": "Delete",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "confirmDeletion": "Confirm Deletion",
    "confirmSave": "Confirm Save",
    "confirmDeleteMessage": "Are you sure you want to delete this item? This action cannot be undone.",
    "confirmSaveMessage": "Are you sure you want to save this item? This action cannot be undone.",
    "lock": "Lock",
    "unlock": "Unlock",
    "unlocking": "Unlocking…",
    "add": "Add",
    "edit": "Edit",
    "saveChanges": "Save Changes",
    "close": "Close",
    "search": "Search",
    "export": "Export",
    "select": "Select",
    "retry": "Try again",
    "enterFullscreen": "Enter fullscreen",
    "exitFullscreen": "Exit fullscreen",
    "yes": "Yes",
    "no": "No",
    "dismiss": "Dismiss",
    "dismissAll": "Dismiss all",
    "discard": "Discard",
    "resolve": "Resolve"
  },
  "shortcuts": {
    "or": "{{first}} or {{second}}",
    "confirmWith": "{{keys}} to confirm",
    "escToCancel": "{{confirm}} · Esc to cancel"
  },
  "shifts": {
    "DAY": "day shift",
    "AFTERNOON": "afternoon shift",
    "NIGHT": "night shift"
  },
  "status": {
    "syncProgress": "Syncing your offline changes - {{done}} of {{total}} done.",
    "syncCount_one": "Syncing {{count}} offline change.",
    "syncCount_other": "Syncing {{count}} offline changes.",
    "syncCarryOn": " You can carry on using Eclipse - just don't close the browser until it finishes.",
    "offlineLong": "You're offline - edits are queued and will sync when you reconnect",
    "offlineShort": "Offline - edits are queued",
    "syncIssues_one": "{{count}} sync issue needs your attention",
    "syncIssues_other": "{{count}} sync issues need your attention",
    "pending_one": "{{count}} offline change is waiting to sync.",
    "pending_other": "{{count}} offline changes are waiting to sync.",
    "lockedShift": "<strong>{{when}}</strong> is locked<wide> - view only</wide>",
    "unsyncedShift": "<strong>{{when}}</strong> has not reached the server<wide> - view only until it syncs</wide>",
    "viewOnly": "This page is <strong>view only</strong><wide> - you do not have permissions to edit.</wide>",
    "backTo": "Back to {{date}} {{shift}}",
    "review": "Review",
    "chipSyncing": "Syncing",
    "chipOffline": "Offline",
    "chipIssues_one": "{{count}} issue",
    "chipIssues_other": "{{count}} issues",
    "chipPending": "{{count}} pending",
    "chipShiftLocked": "Shift locked",
    "chipShiftNotSynced": "Shift not synced",
    "chipViewOnly": "View only",
    "issuesAdded_one": "{{count}} offline change needs your attention. Open the sync issues from the status bar at the top of the screen.",
    "issuesAdded_other": "{{count}} offline changes need your attention. Open the sync issues from the status bar at the top of the screen."
  },
  "shiftTitles": {
    "DAY": "Day Shift",
    "AFTERNOON": "Afternoon Shift",
    "NIGHT": "Night Shift"
  },
  "crumbs": {
    "nightNotStarted": "Night shift has not started yet.",
    "selectDate": "Select a Date",
    "chooseOption": "Choose an Option",
    "noOptions": "No Options Available",
    "showAll": "Show all",
    "lockedCanUnlock": "Shift is locked. Click to unlock.",
    "lockedCannotUnlock": "Shift is locked. You do not have permission to unlock it.",
    "unlockedCanLock": "Shift is unlocked. Click to lock and prevent changes.",
    "unlocked": "Shift is unlocked.",
    "unlockShiftTitle": "Unlock Shift?",
    "lockShiftTitle": "Lock Shift?",
    "unlockShiftBody": "This will allow you and other users to edit data for this shift.",
    "lockShiftBody": "This will prevent you and other users from editing data for this shift.",
    "lockFailed": "Failed to fetch shift editability"
  },
  "connection": {
    "restored": "Connection restored",
    "lost": "Connection lost. Reconnecting"
  },
  "offlineGuard": {
    "title": "Not available offline",
    "body": "This page is not available without an internet connection. Navigate to Operations, Stoppages, or Production to continue working."
  },
  "serverTerms": {
    "Production (Ex-Pit)": "Production (Ex-Pit)",
    "In Pit": "In Pit",
    "Rehandle": "Rehandle",
    "Crushing": "Crushing",
    "Ore": "Ore",
    "Waste": "Waste",
    "Total Ex-Pit Movement": "Total Ex-Pit Movement",
    "Total In-Pit Movement": "Total In-Pit Movement",
    "Total Material Movement": "Total Material Movement",
    "Tonnes": "Tonnes",
    "Blastmaster": "Blastmaster",
    "Blast Pattern": "Blast Pattern"
  },
  "fields": {
    "actions": "Actions",
    "name": "Name",
    "description": "Description",
    "date": "Date",
    "dateFrom": "Date From",
    "dateTo": "Date To",
    "time": "Time",
    "startTime": "Start Time",
    "endTime": "End Time",
    "hour": "Hour",
    "shift": "Shift",
    "type": "Type",
    "status": "Status",
    "total": "Total",
    "active": "Active",
    "comments": "Comments",
    "zone": "Zone",
    "location": "Location",
    "source": "Source",
    "destination": "Destination",
    "material": "Material",
    "materialType": "Material Type",
    "materialTypeClass": "Material Type Class",
    "pitStage": "Pit Stage",
    "oreBlock": "Ore Block",
    "truck": "Truck",
    "machine": "Machine",
    "tonnes": "Tonnes",
    "loads": "Loads"
  },
  "validation": {
    "validNumber": "Please enter a valid number"
  },
  "states": {
    "loading": "Loading…"
  },
  "format": {
    "labelValue": "{{label}}: {{value}}"
  },
  "errors": {
    "generic": "An error occurred",
    "downloadFailed": "Download failed",
    "downloadUnexpected": "Unexpected download error"
  },
  "auth": {
    "checkCredentials": "Login failed. Please check your credentials and try again.",
    "userDetailsFailed": "Failed to retrieve user details.",
    "loginFailed": "Login failed. Please try again.",
    "noAccount": "No account was found for that sign-in. Ask an administrator to create one first.",
    "signInFailed": "Sign-in failed. Please try again."
  },
  "accessChange": {
    "roleNow": "Your role is now {{role}}.",
    "roleChanged": "Your role has changed.",
    "roleNowWithZones": "Your role is now {{role}}, with access to {{zones}}.",
    "roleChangedWithZones": "Your role has changed, with access to {{zones}}.",
    "roleNowNoZones": "Your role is now {{role}}, and you no longer belong to any zone.",
    "roleChangedNoZones": "Your role has changed, and you no longer belong to any zone.",
    "zonesNow": "You now have access to {{zones}}.",
    "noZones": "You no longer belong to any zone.",
    "updated": "Your access has been updated.",
    "lostPage": "You no longer have access to {{page}}, so you've been taken to the dashboard.",
    "signInAgain": "You'll be asked to sign in again soon."
  },
  "errorScreen": {
    "title": "Something went wrong",
    "body": "An unexpected error occurred. Please try again later."
  },
  "clock": {
    "toFace": "Switch to clock face",
    "toDigital": "Switch to digital"
  },
  "mathInput": {
    "decrement": "Decrement",
    "increment": "Increment"
  },
  "timePicker": {
    "clear": "Clear time"
  },
  "changePassword": {
    "title": "Change password",
    "oldPassword": "Old Password",
    "newPassword": "New Password",
    "mustDiffer": "The old and the new passwords must differ."
  },
  "notifications": {
    "title": "Notification",
    "dismissAll": "Dismiss all notifications",
    "viewStoppage": "View stoppage",
    "setAvailable": "The status of plant <plant>{{plant}}</plant> has been set as <up>Up</up>.",
    "setAvailableBy": "The status of plant <plant>{{plant}}</plant> has been set as <up>Up</up> by <user>{{user}}</user>.",
    "setUnavailable": "Status of plant <plant>{{plant}}</plant> has been set as <status>{{status}}</status>.",
    "setUnavailableBy": "Status of plant <plant>{{plant}}</plant> has been set as <status>{{status}}</status> by <user>{{user}}</user>.",
    "generic": "You have a new notification."
  },
  "zoneChip": {
    "tooltip": "<label>Zone: </label><zone>{{zone}}</zone>"
  },
  "shiftNoResults": {
    "unlock": "The shift is locked. If you need to add {{entity}}, <bold>unlock the shift</bold> first on the <home>Home<icon /></home> page.",
    "askAdmin": "The shift is <bold>locked</bold>. If you need to add {{entity}}, <bold>contact an admin</bold>."
  },
  "showAll": {
    "trucks": "Show all trucks",
    "otherTrucks": "Other trucks",
    "models": "Show all models",
    "otherModels": "Other plant models",
    "loadingMachines": "Show all loading machines",
    "otherLoadingMachines": "Other loading machines"
  },
  "verification": {
    "row": "row",
    "partial": "{{checked}} of {{total}} checked, {{outstanding}} still to check",
    "acceptRemaining": "Accept the remaining {{outstanding}} of {{total}}",
    "checked": "Checked",
    "unchecked": "Recorded by telemetry, not checked by anyone yet",
    "needsChecking": "Needs checking",
    "needsCheckingAccept": "Needs checking. Accept this {{subject}} as recorded",
    "accept": "Accept this {{subject}} as recorded"
  },
  "viewOnly": {
    "hint": "This page is view only"
  },
  "shiftCalendar": {
    "noShifts": "No shifts exist for this date. Create them in Operations List first.",
    "offline": "Not available offline. Only shifts saved on this device can be opened."
  },
  "options": {
    "all": "(All)"
  },
  "syncIssues": {
    "loads_one": "{{count}} loads",
    "loads_other": "{{count}} loads",
    "hour": "hour {{hour}}",
    "logged": "logged {{time}}",
    "about": " ({{parts}})",
    "conflict": "A {{entity}} conflict{{about}}: it was edited by someone else",
    "shiftLocked": "A {{entity}} change{{about}} was rejected: shift is locked",
    "failed": "A {{entity}} change{{about}} failed: {{reason}}",
    "serverError": "server error",
    "notFound": "A {{entity}} change{{about}} couldn't be applied because the record no longer exists on the server (it may have been deleted). Re-enter it if it's still needed, then dismiss this.",
    "none": "Nothing left to deal with."
  },
  "conflict": {
    "fields": {
      "diggerLoader": "Digger / Loader",
      "movementFrom": "Movement From",
      "movementTo": "Movement To",
      "breakdownCode": "Breakdown Code",
      "workOrder": "Work Order",
      "repairsFaults": "Repairs / Faults",
      "incident": "Incident"
    },
    "started": "started {{time}}",
    "notPermitted": "You no longer have permission to make this change, so it could not be applied.",
    "shiftLocked": "That shift was locked before this change reached the server, so it could not be applied.",
    "notFound": "What this change belongs to no longer exists, so it could not be applied.",
    "couldNotApply": "The server could not apply this change.",
    "notSaved": "This {{entity}} could not be saved.",
    "editedOffline": "This {{entity}} was edited by someone else while you were offline. Choose how to resolve:",
    "field": "Field",
    "yourVersion": "Your version",
    "serverVersion": "Server version",
    "keepMine": "Keep mine",
    "keepTheirs": "Keep theirs"
  },
  "syncEntities": {
    "stoppage": "stoppage",
    "loading": "truck load",
    "diggingPattern": "digging location",
    "completeShift": "shift completion",
    "operationLocation": "machine location",
    "engineHours": "engine hours entry",
    "geoRehandle": "rehandle/crushing entry",
    "drillingSession": "drilling session",
    "drillingPattern": "pattern on the rig's drilling",
    "drillingLine": "drilling line",
    "operationMeter": "rig meter reading",
    "gcLine": "RC drilling line",
    "drilledHole": "drilled hole",
    "holeDip": "dip",
    "holeCharge": "hole charge",
    "explosiveMovement": "explosives movement",
    "firing": "firing record",
    "misfire": "misfire report",
    "consumableMovement": "consumables issue",
    "componentAction": "bit or steel change"
  },
  "offlineShift": {
    "day": "{{date}} Day shift",
    "afternoon": "{{date}} Afternoon shift",
    "night": "{{date}} Night shift"
  },
  "offline": {
    "needsConnection": "Your changes need a connection, so they cannot be saved offline. Reconnect and try again.",
    "noIdYet": "That load could not be saved offline because it has no id yet. Re-enter it and try again.",
    "serverKeptFailing": "The server kept failing (HTTP {{code}}) for 7 days, so this change could not be applied. It has been removed from the queue - please re-enter it.",
    "timedOut": "{{what}} did not finish within {{seconds}} seconds"
  },
  "holeChecks": {
    "dipShortOfDesign": "{{hole}} dipped at {{depth}} m is {{gap}} m short of its {{reference}} m design, outside the {{tolerance}} m tolerance. Choose clean out or redrill if it needs one.",
    "dipShortOfDrilled": "{{hole}} dipped at {{depth}} m is {{gap}} m short of its {{reference}} m drilled depth, outside the {{tolerance}} m tolerance. Choose clean out or redrill if it needs one.",
    "dipPastDesign": "{{hole}} dipped at {{depth}} m is {{gap}} m past its {{reference}} m design, outside the {{tolerance}} m tolerance. Choose backfill if it needs one.",
    "dipPastDrilled": "{{hole}} dipped at {{depth}} m is {{gap}} m past its {{reference}} m drilled depth, outside the {{tolerance}} m tolerance. Choose backfill if it needs one.",
    "drillShort": "{{hole}} at {{depth}} m is {{gap}} m short of its {{design}} m design, outside the {{tolerance}} m tolerance.",
    "drillPast": "{{hole}} at {{depth}} m is {{gap}} m past its {{design}} m design, outside the {{tolerance}} m tolerance."
  },
  "detectionSource": {
    "manual": "Manual",
    "gps": "GPS",
    "vendor": "Vendor"
  }
}
